module.exports = __webpack_public_path__ + "img/17.e68e22b9.png";